import { createClient } from "@supabase/supabase-js"
import { SUPABASE_ANON_PUBLIC_KEY, SUPABASE_URL } from "../env"
import { Database } from "./database.types"

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_PUBLIC_KEY
)
